<template>
  <nav
    class="navbar navbar-vertical fixed-start navbar-expand-md pt-md-7"
    id="sidebar"
  >
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarCollapse"
        aria-controls="sidebarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <Logo height="30" class="d-md-none" />

      <div class="navbar-user d-md-none">
        <div class="dropdown">
          <a
            href="#"
            id="sidebarIcon"
            class="dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="avatar avatar-sm">
              <img
                src="@/presentation/assets/img/logo-square.svg"
                class="avatar-img rounded-circle"
                alt="..."
              />
            </div>
          </a>

          <div class="dropdown-menu dropdown-menu-end">
            <router-link
              :to="{
                name: routes.admins.detail?.name,
                params: { id: session?.id },
              }"
              class="dropdown-item"
              >Minha conta</router-link
            >
            <hr class="dropdown-divider" />
            <router-link
              :to="routes.login.path"
              class="dropdown-item text-danger"
              >Sair</router-link
            >
          </div>
        </div>
      </div>
      <div class="collapse navbar-collapse" id="sidebarCollapse">
        <SidebarHeaderItem
          v-for="(screen, index) in screens"
          :header="screen"
          :key="index"
        />
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/infra/store";
import { SidebarMenu } from "@/utils";
import { computed, ref } from "vue";
import { routes } from "../router";
import SidebarHeaderItem from "./SidebarHeaderITem.vue";


const screens = ref(SidebarMenu);
const session = computed(() => useMainStore().session);
</script>
